<template>
    <div class="container-fluid">
        <div class="herosection"
            :style="{
                backgroundImage: image ? `url('${image}')` : `url('${require('@/assets/images/HeroBg.png')}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                height: '924px'
            }"
        >
            <NavbarSection />
            <!-- <img src="../assets/images/sports/bookcourtoverlay.png" alt="overlay" class="overlay-img" /> -->
            <div class="heroWriteup">
                 <p v-html="description"></p>
                <button @click="bookCourt">
                    Check Court Availability
                </button>
            </div>
        </div>

    <ReusableAccordion />

    <FooterSection />
</div>
</template>


<script setup>
/* eslint-disable */
import NavbarSection from '@/components/NavbarSection.vue';
import { ref, onMounted } from 'vue';
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Bookmark, CalendarDays } from 'lucide-vue-next';
import ReusableAccordion from '@/components/ReusableAccordion.vue';
import router from "@/router";
import axios from 'axios';

const dateRange = ref(null);
const isMember = ref(false);
const loggedId = ref();
const dataList = ref([]);
const courtScheduleList = ref([]);

const fullName = ref('');
const emailAddress = ref('');
const phoneNumber = ref('');
const age = ref('');
const court = ref('');
const date = ref('');
const time = ref('');
const faqList = ref([])

const bannerList = ref([]);
const image = ref('');
const title = ref('');
const description = ref('');
const selectedDate = ref(getTodayDate())

onMounted( async () => {
    loggedId.value = localStorage.getItem('userid');
    await listRecords();
    await faqLists()
    await listBanner()
    await fetchScheduleByDate()
});

let base_url = process.env.VUE_APP_BASE_LIVE_URL

function getTodayDate () {
        return new Date().toISOString().split('T')[0]
}


const fetchScheduleByDate = async () => {
      try {
        const response = await axios.post('/schedule_court_listing.php', {date: selectedDate.value})
        if (response.data.status) {
            courtScheduleList.value = response.data.data
        }
      } catch (error) {
        console.error(error.message)
      }
}

const listBanner = async () => {
  try {
    const config = 'book-a-court';
    const response = await axios.get(`/website_banner_listing.php?id=${config}`, { });
    bannerList.value = response.data.data;
    title.value = bannerList.value.title
    description.value = bannerList.value.description
    image.value = `${base_url}${bannerList.value.banner_image}`
    //console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listRecords = async () => {
  try {
    const response = await axios.get('/court_lists.php', { });
    if (response.data.status) dataList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};
const bookCourtNow = async () => {
    try {

       // Validate inputs
        if (
            !fullName.value ||
            !emailAddress.value ||
            !phoneNumber.value ||
            !age.value ||
            !court.value ||
            !date.value ||
            !time.value
        ) {
            alert("All fields are required!");
            return;
        }

        // Make the signup API request
        const response = await axios.post('/book_court.php', {
             memberId: loggedId.value,
             fullName: fullName.value,
             emailAddress: emailAddress.value,
             phoneNumber: phoneNumber.value,
             age: age.value,
             court: court.value,
             date: date.value,
             time: time.value,
             created_by: loggedId.value,
        });

        alert(response.data.message);
        router.push("/payment-panel")
            
    } catch (error) {
        alert(error.response ? error.response.data.message : error.message);
        console.error('Error:', error.response ? error.response.data : error.message);
    }
}
const signIn = () => {
    router.push('/login');
}
const bookCourt = () => {
    // if (courtScheduleList.value.length <= 0) {
    //     alert("There's no court schedule at the moment!");
    //     return;
    // }
    router.push('/court-booking');
}

const faqLists = async () => {
    try {

        // Make the signup API request
        const response = await axios.get('/faq_list.php', {
        });

        faqList.value = response.data.data;

            
    } catch (error) {
        alert(error.response ? error.response.data.message : error.message);
        console.error('Error:', error.response ? error.response.data : error.message);
    }
}
</script>


<style lang="scss" scoped>
.herosection {
    border-radius: 20px;
    background-image: url('../assets/images/sports/bookcourt.jpg');
    background-size: cover;
    height: 764px;
    padding: 10px;
    position: relative;
    width: 100%;
    overflow: hidden;
    padding:1.5rem 4rem 0 4rem;
}
.heroWriteup,
NavbarSection {
    position: relative;
    z-index: 2;
    /* ensures text and navbar appear above overlay */
}

.heroWriteup {
        position: absolute;
        max-width: 650px;
        text-align: left;
        bottom: 15%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        color: white;

        h2 {
            font-size: 52px;
            font-weight: 700;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 18px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            text-align: center;

        }

        button {
            background-color: #ed4e24;
            width: 296px;
            height: 64px;
            border-radius: 40px;
            border: 4px solid #ED4E241A;
            margin-top: 2rem
        }
}


.member-booking {
    margin-top: 5rem;
    margin-bottom: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;


    h2 {
        font-size: 48px;
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        color: #000000;
    }

    p {
        font-size: 20px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        max-width: 800px;
    }

    button {
        background-color: #ED4E24;
        width: 296px;
        height: 64px;
        border-radius: 40px;
        border: 4px solid #ED4E241A;
        margin-top: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;

        p {
            padding: 0%;
            margin: 0%;
            font-size: 16px;
            font-weight: 500;
            color: #FFFFFF;
            font-family: "Open Runde", sans-serif
        }
    }
}

.guest-booking {
    margin-top: 5rem;
    margin-bottom: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;


    h2 {
        font-size: 48px;
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        color: #000000;
    }

    p {
        font-size: 20px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        max-width: 800px;
    }
}

.overlay-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
    background: linear-gradient(180deg, rgba(9, 73, 35, 0) 0%, #01170A 100%);
}

.herosection::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.5);
    /* black with 40% opacity */
    z-index: 1;
}

.pioneers-section {
    margin-top: 5rem;

    h2 {
        font-size: 48px;
        font-weight: 700;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 20px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        margin-bottom: 4rem;
    }
}

.form-container {
    display: flex;
    max-width: 80%;
    margin: auto;
    justify-content: space-between;
    align-items: start;
    border: 1px solid #EBF1FF;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 2rem;
    border-radius: 20px;
    gap: 20px;

    .personal-details {
        width: 50%;
        border: 1px solid #EBF1FF;
        border-radius: 20px;
        padding: 40px;

        h2 {
            font-size: 24px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            text-align: left;
        }

        p {
            font-size: 14px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            color: #020617;
            text-align: left;
        }
    }

    .court-details {
        width: 50%;
        border: 1px solid #EBF1FF;
        border-radius: 20px;
        padding: 40px;

        h2 {
            font-size: 24px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            text-align: left;
        }

        p {
            font-size: 14px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            color: #020617;
            text-align: left;
        }
    }

    .form-group {
        margin-bottom: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;

    }

    .picker-container {
        display: flex;
        justify-content: space-between;
        padding: 0 16px;
        align-items: center;
        border: 1px solid #94A3B8;
        border-radius: 8px;
        width: 100%;
    }

    .date-picker {
        border: none;
        padding: 12px 0%;
        border-radius: 8px;
        color: #94A3B8;

        outline: none;
    }

    label {
        margin-bottom: 0.3rem;
        font-weight: bold;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        font-weight: 400;
        color: #020617;
    }

    input {
        padding: 12px 16px;
        border: 1px solid #94A3B8;
        color: #94A3B8;
        border-radius: 8px;
        width: 100%;
    }

    select {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #ccc;
        border-radius: 5px;
        outline: none;
        font-size: 1rem;
        color: #94A3B8;
    }
}

.book-court {
    margin: 2rem auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 60px;
    border-radius: 40px;
    gap: 10px;
    background-color:#ED4E24;
    border: 4px solid #4D4C4C1A;
    cursor: pointer;
    transition: all 0.3s ease-in-out 0.1s;
    color: #fff;

    p {
        color: #fff !important;
        padding: 0%;
        margin: 0%;
        font-size: 16px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        transition: color 0.3s ease-in-out 0.1s;
    }
}

.book-court:hover {
    background-color: #ED4E24;
    color: #fff;
}

.book-court:hover p {
    color: #fff;
}

.form-container.centered {
    justify-content: center;
    /* center the child */
}

.form-container.centered .court-details {
    width: 60%;
    /* optional, make it wider when centered */
}

@media (max-width: 768px) {

    .overlay-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        /* make it cover */
        height: 100%;
        object-fit: cover;
        /* prevent distortion */
        opacity: 0.6;
        /* control transparency */
    }

    .herosection {
        border-radius: 20px;
        background-image: url('../assets/images/HeroBg.png');
        background-size: cover;
        height: 624px;
        padding: 10px;
        position: relative;
        width: 100%;

        .heroWriteup {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 90%;
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 10px;
            justify-content: center;
            align-items: center;
            color: white;

            h2 {
                font-size: 32px;
                /* shrink a bit for small screens */
                font-weight: 700;
                font-family: "Open Runde", sans-serif;
            }

            p {
                font-size: 16px;
                font-weight: 500;
                font-family: "Open Runde", sans-serif;
            }
        }

        .authbuttons {
            display: flex;
            flex-direction: column;
            gap: 1rem;

            .login {
                background-color: #ffffff;
                border: 2px solid #0000001f;
                color: black;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .login:hover {
                border: 2px solid #ed4e24;
            }

            .register {
                background-color: #ed4e24;
                border: 2px solid #0000001f;
                color: white;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .register:hover {
                background-color: #c63d1c;
            }
        }

    }


    .form-container {
        display: flex;
        max-width: 100%;
        flex-direction: column;
        margin: auto;
        justify-content: space-between;
        align-items: start;
        border: 1px solid #EBF1FF;
        padding: 12px;
        border-radius: 20px;
        gap: 20px;

        .personal-details {
            width: 100%;
            border: 1px solid #EBF1FF;
            border-radius: 20px;
            padding: 12px;

            h2 {
                font-size: 24px;
                font-weight: 400;
                font-family: "Open Runde", sans-serif;
                text-align: left;
            }

            p {
                font-size: 14px;
                font-weight: 400;
                font-family: "Open Runde", sans-serif;
                color: #020617;
                text-align: left;
            }
        }

        .court-details {
            width: 100%;
            border: 1px solid #EBF1FF;
            border-radius: 20px;
            padding: 12px;

            h2 {
                font-size: 24px;
                font-weight: 400;
                font-family: "Open Runde", sans-serif;
                text-align: left;
            }

            p {
                font-size: 14px;
                font-weight: 400;
                font-family: "Open Runde", sans-serif;
                color: #020617;
                text-align: left;
            }
        }

        .form-group {
            margin-bottom: 2rem;
            display: flex;
            flex-direction: column;
            justify-content: start;
            align-items: start;

        }

        .picker-container {
            display: flex;
            justify-content: space-between;
            padding: 0 16px;
            align-items: center;
            border: 1px solid #94A3B8;
            border-radius: 8px;
            width: 100%;
        }

        .date-picker {
            border: none;
            padding: 12px 0%;
            border-radius: 8px;
            color: #94A3B8;

            outline: none;
        }

        label {
            margin-bottom: 0.3rem;
            font-weight: bold;
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            font-weight: 400;
            color: #020617;
        }

        input {
            padding: 12px 16px;
            border: 1px solid #94A3B8;
            color: #94A3B8;
            border-radius: 8px;
            width: 100%;
        }

        select {
            width: 100%;
            padding: 12px 16px;
            border: 1px solid #ccc;
            border-radius: 5px;
            outline: none;
            font-size: 1rem;
            color: #94A3B8;
        }
    }
}
</style>
